import { gql } from '@apollo/client';

export interface IGetLicenseResponse {
  cashBoxLicenseToken: string;
}
export const GET_LICENSE = gql`
  query cashBoxLicenseToken {
    cashBoxLicenseToken
  }
`;
